import { render } from "./index.vue?vue&type=template&id=6ed9d5da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6ed9d5da&lang=scss&scoped=true"

import exportComponent from "/Users/zuzhiming/xlc-work/xlc-kuihuaguanwang/Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed9d5da"]])

export default __exports__